module.exports = __webpack_public_path__ + "static/aeo-hizmetleri-44cb88e32c134781ba52f3cceb82dc8b.webp";